import React from "react";
import GiftsProduct from "./product";
import giftProducts from "src/data/products-gift";

function GiftsProducts({ selectedProducts = [] }) {
  return Object.keys(giftProducts).map((giftProductSku) => {
    const giftProduct = giftProducts[giftProductSku];
    const isProductInBasket =
      selectedProducts.filter(
        (selectedProduct) => selectedProduct.id === giftProduct.id
      ).length > 0;
    return (
      <GiftsProduct
        key={giftProduct.id}
        data-selector={`GiftsProduct_${giftProduct.id}`}
        product={giftProduct}
        isProductInBasket={isProductInBasket}
      />
    );
  });
}

export default GiftsProducts;
